import { render, staticRenderFns } from "./Admiral.vue?vue&type=template&id=7e0de8e0"
import script from "./Admiral.vue?vue&type=script&lang=js"
export * from "./Admiral.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src2296946445/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7e0de8e0')) {
      api.createRecord('7e0de8e0', component.options)
    } else {
      api.reload('7e0de8e0', component.options)
    }
    module.hot.accept("./Admiral.vue?vue&type=template&id=7e0de8e0", function () {
      api.rerender('7e0de8e0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/reminders/documents/headers/Admiral.vue"
export default component.exports